import { useEffect, useRef, useState } from "react";

import { normalizarArquivoPrescricao } from "../../utils/prescricaoArquivos";

export default function usePreviewPrescricao() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [blobUrl, setBlobUrl] = useState("");
  const [arquivoPreview, setArquivoPreview] = useState(null);
  const blobUrlRef = useRef("");

  const limparBlobUrl = ({ resetState = true } = {}) => {
    if (blobUrlRef.current) {
      window.URL.revokeObjectURL(blobUrlRef.current);
      blobUrlRef.current = "";
    }

    if (resetState) {
      setBlobUrl("");
    }
  };

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        window.URL.revokeObjectURL(blobUrlRef.current);
      }
    };
  }, []);

  const abrirPreviewComBlob = async (arquivo, carregarBlob) => {
    const arquivoNormalizado = normalizarArquivoPrescricao(arquivo);

    setOpen(true);
    setLoading(true);
    setArquivoPreview(arquivoNormalizado);
    limparBlobUrl();

    try {
      const blob = await carregarBlob(arquivoNormalizado);
      const url = window.URL.createObjectURL(blob);
      blobUrlRef.current = url;
      setBlobUrl(url);
    } catch (error) {
      setOpen(false);
      setArquivoPreview(null);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const abrirPreviewLocal = (arquivo) => {
    const arquivoNormalizado = normalizarArquivoPrescricao(arquivo);
    const url = window.URL.createObjectURL(arquivo);

    limparBlobUrl();
    blobUrlRef.current = url;
    setBlobUrl(url);
    setArquivoPreview(arquivoNormalizado);
    setLoading(false);
    setOpen(true);
  };

  const fecharPreview = () => {
    setOpen(false);
    setLoading(false);
    setArquivoPreview(null);
    limparBlobUrl();
  };

  return {
    open,
    loading,
    blobUrl,
    arquivoPreview,
    abrirPreviewComBlob,
    abrirPreviewLocal,
    fecharPreview,
  };
}
